import { useState } from 'react';

import { IS_INFLUENCER_CAMPAIGN_BAR_DISMISSED_KEY } from 'src/features/dashboard/dashboard.constants';

export const useShowInfluencerCampaignBar = (): [boolean, () => void] => {
  const [isClosed, setIsClosed] = useState(false);

  const isPreviouslyDismissed = localStorage.getItem(IS_INFLUENCER_CAMPAIGN_BAR_DISMISSED_KEY) === true.toString();
  const isShowInfluencerCampaignBar = !isClosed && !isPreviouslyDismissed;

  const hideInfluencerCampaignBar = () => {
    setIsClosed(true);
    localStorage.setItem(IS_INFLUENCER_CAMPAIGN_BAR_DISMISSED_KEY, true.toString());
  };

  return [isShowInfluencerCampaignBar, hideInfluencerCampaignBar];
};
